import {Exception} from './Exception';
import Handlers from './Handlers';

export abstract class AbstractDatoException extends Exception {
  constructor(message: string) {
    super(message, Handlers.HANDLER_TYPES.slack);
  }
}

